import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MemberService } from './../../rest/api/member.service';
import { HelperService } from './../../services/helper.service';

import { AuthService } from './../../services/auth.service';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;
  returnUrl: string;

  clientId: any;
  clientSecret: any;
  private destroy$ = new Subject<void>();
  private queryParamsSubscription: Subscription;

  constructor(
    public router: Router,
    public fb: FormBuilder,
    public memberService: MemberService,
    public helperService: HelperService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public title: Title
    ) {
      this.title.setTitle('Login | Betaspace');

      this.clientId = environment.clientId;
      this.clientSecret = environment.clientSecret;

      const url = this.route.snapshot.queryParams.returnUrl;
      // if (url && url !== undefined) {
      //   this.returnUrl = `${url}`;
      // } else {
      this.returnUrl = '/member/home';
      // }

      this.queryParamsSubscription = this.route.queryParams.pipe(
        takeUntil(this.destroy$)
      ).subscribe(params => {
        if (params.sessionExpired) {
          this.errorMsg = 'Your session has expired.Please login again!';
          this.removeParams();
        }
      });
    }

  ngOnInit() {
    this.loginFormInit();
    this.authService.loginReceived.pipe(
      takeUntil(this.destroy$)
    ).subscribe(this.loginReceived.bind(this));
    
    this.authService.loginError.pipe(
      takeUntil(this.destroy$)
    ).subscribe(this.loginError.bind(this));
    
    this.authService.profileReceived.pipe(
      takeUntil(this.destroy$)
    ).subscribe(this.profileReceived.bind(this));
    
    this.authService.profileError.pipe(
      takeUntil(this.destroy$)
    ).subscribe(this.loginError.bind(this));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  loginFormInit() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      password: ['', [Validators.required, Validators.maxLength(20)]]
    });
  }

  submit(value) {
    if (!this.loginForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    this.loginMembers(data);
  }

  loginMembers(data) {
    const formData = {
      username: data.email,
      password: data.password,
      client_id: this.clientId,
      client_secret: this.clientSecret,
      grant_type: 'password'
    };
    data = this.helperService.updateJsonFormat(formData);
    this.authService.login(data);
  }

  loginReceived(res) {
    this.authService.profile(res);
  }

  profileReceived(res) {
    window.location.href = this.returnUrl;
  }

  loginError(err) {
    this.isSubmitted = false;
    this.isSubmitting = false;
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (err && err.status === 401) {
      this.errorMsg = 'Verify your account email address.';
      this.reset();
      setTimeout(() => {
        this.errorMsg = undefined;
      }, 5000);
    }

    if (err && err.error && err.error.errors) {
      this.errors = err.error.errors;
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    } else {
      this.errorMsg = 'Invalid email address / password.';
    }
  }

  reset() {
    this.loginForm.reset();
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }


  signOut(): void {
    this.authService.logout();
  }

  removeParams() {
    const thisobject = this;
    setTimeout(() => {
      thisobject.router.navigate([], {
        queryParams: {
          sessionExpired: null,
        },
        queryParamsHandling: 'merge'
      });
      thisobject.errorMsg = undefined;
    }, 5000);
  }

}
